import React, { useState } from "react";

const CookiePopup = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="cookie-popup">
      <p>
        Ta strona korzysta z plików cookie i zbiera dane o Twojej lokalizacji. 
        Więcej informacji znajdziesz w naszej <a href="/privacy-policy">polityce prywatności</a>.
      </p>
      <button onClick={() => setVisible(false)}>Akceptuję</button>
    </div>
  );
};

export default CookiePopup;
